import { createColumnText, widthOptions } from '../../../components/table/function';

export const columns = () => {
  return [
    createColumnText('ชื่อ', 'employeeName', widthOptions(150)),
    createColumnText('ชื่อสาขา', 'branchName', widthOptions(150)),
    createColumnText('เลขที่ใบเสร็จ', 'barcodeValue', widthOptions(150)),
  ];
};
